import { render, staticRenderFns } from "./contract-form.vue?vue&type=template&id=37768dc6&"
import script from "./contract-form.vue?vue&type=script&lang=js&"
export * from "./contract-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports